import { Text, Flex, Heading } from '@everlywell/ui-kit';
import SectionContainer from 'components/PageSections/components/SectionContainer';
import { GatsbyImage as Img } from 'gatsby-plugin-image';
import React from 'react';
import { Media } from 'utils/types/contentfulTypes';

export interface MedicalConciergeProps {
  eyebrow?: string;
  title?: string;
  images?: Media[];
  theme?: {
    textColor: string;
    backgroundColor: string;
  };
}

const MedicalConcierge: React.FC<MedicalConciergeProps | null> = (props) => {
  if (!props) {
    return null;
  }

  const { eyebrow, theme, title, images } = props;

  return (
    <SectionContainer size={['sm', 'sm', 'md', 'xl']}>
      <Flex
        background={theme?.backgroundColor}
        width="100%"
        paddingX={['4', '10']}
        paddingY={['4', '4']}
        borderRadius="xl"
        gap={5}
        display={['block', 'flex']}
      >
        {images
          ? images.map(
              (image, index) =>
                image.desktopImage?.gatsbyImageData && (
                  <Img
                    key={index}
                    image={image.desktopImage?.gatsbyImageData}
                    alt={image.desktopImageAltText || ''}
                    style={{
                      width: '128px',
                      height: 'auto',
                    }}
                  />
                ),
            )
          : null}
        <Flex flexFlow="column" alignItems="flex-start" justifyContent="center">
          {eyebrow ? (
            <Text size="lg" color={theme?.textColor} marginTop={['4', null]}>
              {eyebrow}
            </Text>
          ) : null}
          {title ? <Heading as="h3">{title}</Heading> : null}
        </Flex>
      </Flex>
    </SectionContainer>
  );
};

export default MedicalConcierge;
